/** The callout's default look — shared by the callouts themselves and the guide that places one. */
export const CALLOUT_BG = '#f8c471'
export const CALLOUT_TEXT = '#1a1a1a'
